import React, {Component} from 'react';
import styled from 'styled-components';
// use filter, sort, pagination, and table state
import { useTable, useFilters, useSortBy, usePagination, useTableState } from 'react-table';
import {DebounceInput} from 'react-debounce-input';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css'

// Number of minimum characters to show the balloon help on cells.
const SHOW_TOOLTIP_THRESHOLD = 65;
const SHOW_TOOLTIP_NON_ASCII_THRESHOLD = 25;

const Styles = styled.div`
  padding: 1rem;
  padding-left: 0;
  padding-right: 0;
  padding-top: 20px;
  font-family: 'Helvetica Neue', Arial, Helvetica, 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'Meiryo', 'メイリオ', Osaka, 'MS PGothic', sans-serif;
  .hidden {
    display: none;
  }
  .global-search {
    font-size: 12px;
    width: 200px;
    margin-bottom: 10px;
    padding-left: 25px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-left: -12px;
    border: 1px solid rgba(0,0,0,0.1);
    background: #fff;
    border-radius: 3px;
    line-height: 13px;
  }
  .global-search:focus {
    outline: none;
    border: 1px solid rgba(0,0,0,0.3);      
  }
  .global-search.dictionary {
    width: 130px;
  }

  .fal.fa-search {
    color: #999;
    font-size: 12px;
    position: relative;
    right: -8px;
  }
  .table-wrapper {
    overflow-x: auto;
    white-space: nowrap;
    border-right: 1px solid rgb(221, 221, 221);
    table {
      tbody {
        tr.selected {
          td {
            background-color: #eee;
          }
        }
      }
    }
  }
    
  table {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right-width: 0;
    border-spacing:0;
    background-color: #f8f8f8;

    th {
      border-right: 1px solid #ddd;
      border-top: 0 solid #ddd;
      border-bottom: 1px solid #ddd;
      display: table-cell;
      max-width: 400px;
      vertical-align: middle;
      background-color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      padding-top: 5px;
      height: 50px;
      position: relative;
      height: 18px;
      font-size: 14px;
      font-weight: 600;
      color: #4d4d4d;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align:left;
      .column-name-wrapper {
        padding-bottom: 5px;
        .column-type {
          height: 17px;
          font-size: 12px;
          font-weight: 300;
          color: #4d4d4d;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-left: 10px;
          padding-right: 10px;
          padding-top: 3px;
          padding-bottom: 2px;
          .fas.fa-hashtag {
            color: #4caf50;
            padding-right: 4px;
          }
          .fas {
            padding-top: 2px;
          }
          .fa-font {
            color: #0288d1;
            padding-right: 8px;
          }
          .fa-factor:before {
            content: "F";
            font-family: Georgia, Cambria, "Times New Roman", Times, serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-size: 13.5px;
            font-weight: 600;
          } 
          .fas.fa-factor {
            color: #0288d1;
            padding-left: 4px;
            padding-right: 9px;
          }

          .fa-hashtag {
            color: #4caf50;
            padding-right: 8px;
          }

          .fa-calendar {
            color: #2196f3;
            padding-left: 3px;
            padding-right: 8px;
            padding-top:2px;
          }

          .fa-arrows-h {
            color: #0288d1;
            padding-left: 2px;
            padding-right: 7px;
          }

          .fa-toggle-on {
            color: #0288d1;
            padding-left: 2px;
            padding-right: 6px;
          }

          .fa-bars {
            color: #ca3cf0;
            padding-left: 3px;
            padding-right: 8px;
          }
      
          .fa-question,
          .fa-question-circle {
            color: #0288d1;
            padding-left: 4px;
            padding-right: 9px;
          }
        }
        .column-name {
          height: 18px;
          font-size: 14px;
          font-weight: 600;
          color: #4d4d4d;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-top: 4px;
          padding-left: 10px;
          padding-right: 10px;
        }
        .column-name.numeric,
        .column-type.numeric  {
          text-align: right;
          width: calc(100% - 20px);
        }
        .column-sort.numeric {
          vertical-align: top;
          
        }
      }
      .filter-container {
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 2px;
        padding-bottom: 2px;
        background-color: #fff;
        border-top: 1px solid rgb(221, 221, 221);
        input {
          width: calc(100% - 15px);
          max-width: 400px;
          min-width: 100px;
          margin-top: 5px;
          margin-bottom: 5px;
          margin-left: -1px;
          border: 1px solid rgba(0,0,0,0.1);
          background: #fff;
          padding: 5px 7px;
          border-radius: 3px;
        }
        input:focus {
          outline: none;
          border: 1px solid rgba(0,0,0,0.3);
        }
      }
      .filter-container.empty {
        background-color: #fff;
        border-top: none;
      }
      .filter-container.numeric {
        text-align: right;
        input {
          margin-left:0;
          margin-right: -1px;
        }
      }
      .filter-container.dictionary {
        input {
          max-width: calc(100% - 15px);
          min-width: calc(100% - 15px);
        }
      }
    }
    th:first-of-type {
      width: 100px;
    }
    
    td {
      border-right: 1px solid #eee;
      border-bottom: 1px solid #ddd;
      display: table-cell;
      max-width: 400px;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 30px;
      font-size: 14px;
      background-color: #fff;
      font-weight: 400;
      .sorted-bar {
        position: absolute;
        height: calc(70%);
        top: 15%;
        padding: 0px;
        opacity: 0.6;
        background-color: rgb(153, 228, 245);
      }
      .sorted-bar.negative {
        background-color: rgb(247, 160, 153);
      }
      .sorted-value-span {
        position:relative;
      }

    }
    
    td.right,
    td.is-id {
      text-align: right;
    }
    td.character {
      span, a {
        display: block;
        max-width: 400px;
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      a {
        color: rgb(77, 77, 77);
      }
    }
    td {
      a {
        color: rgb(77, 77, 77);
      }
    }
    td.right {
      height: calc(100%);
      min-height: calc(100%);
    }
    td.right.sorted {
      position: relative;
    }
    td.is-id {
      background-color: #fff;
      color: #808080;
    }
    td.is-na {
      color: #aaa;
    }
  }
  .pagination {
    float: right;
    margin-top: -50px;
    padding-top: 10px;
    button {
      font-family: 'Helvetica Neue',Arial,Helvetica,sans-serif;
    }
    .rows-info {
      margin-right: 16px;
      display: inline-block;
      margin: 6px 8px;
      margin-left: 0;
      color: rgba(0, 0, 0, 0.6);
      font-size: 14px;
      transform: translateY(3px);
    }
    select {
      background-color: #fff;
      color: #4d4d4d;
      font-size: 14px;
      margin-left: 30px;
      margin-right: 30px;
      font-family: 'Helvetica Neue',Arial,Helvetica,sans-serif;
      background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 95% 50%;
      -webkit-appearance: none;
      appearance: none;
      height: 25px;
      width: 133px;
      padding-left: 8px;
      border-color: rgb(204, 204, 204);
      outline: none;
      transform: translateY(3px);
    }
    select:focus,
    select:focus:hover {
      outline: none;
    }
    button {
      font-size: 14px;
      padding: 0;
      border: none;
      background-color: transparent;
      cursor: pointer;
      transform: translateY(3px);
      span {
        display: inline-block;
        padding: 6px 12px;
        border-radius: 3px;
      }
    }
    button:focus {
      outline: none;
    }
    .go-to-page {
      margin-left: 15px;
    }
    .go-to-label {
      font-size: 14px;
      margin-left: 10px;
    }
  }`

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  //const count = preFilteredRows.length

  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`Type to search`}
    />
  )
}

// Our table component
function Table({ columns, data, defaultSorted, nrow, maxValues, minValues, summaryJSON}) {
  const filterTypes = React.useMemo(
    () => ({
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined && rowValue !== null/*"<NA>"*/
            ? String(rowValue)
                .toLowerCase()
                .indexOf(String(filterValue).toLowerCase()) > -1
            : false
        })
      },
    }),
    []
  )

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )

  const tableState = useTableState({ pageIndex: 0, pageSize: 20 })
 
  const { 
      getTableProps, 
      headerGroups,
      rows,
      prepareRow,
      page,
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: [{pageIndex, pageSize}] 
    } = useTable({
          columns,
          data,
          defaultColumn, // Be sure to pass the defaultColumn option
          filterTypes,
          state: tableState
        },
        useFilters, // useFilters!
        useSortBy,
        usePagination
      );
  
  /**
   * API to get get a data type icon.
   * @param {String} dataType - data type of the column
   */ 
  const getDataTypeIcon = dataType => {
    if(/\.model/.test(dataType)){
      return "fas fa-question"; 
    } else if(/numeric|integer/.test(dataType)){
      return "fas fa-hashtag";
    } else if (/POSIX/.test(dataType)) { // take care of POSIXt, POSIXct, POSIXlt 
      return "far fa-calendar";
    } else if (/(difftime|hms)/.test(dataType)) {
      return "fas fa-arrows-h"; // TODO: find icon
    } else if (/Duration/i.test(dataType)) {
      return "fas fa-arrows-h"; // TODO: find icon
    } else if (/Interval/i.test(dataType)) {
      return "fas fa-arrows-h"; // TODO: find icon
    } else if (/Period/.test(dataType)) {
      return "fas fa-arrows-h"; // TODO: find icon
    } else if (/^list/.test(dataType)) {
      return "fas fa-bars"; 
    } else if (/^logical/.test(dataType)) {
      return "fas fa-toggle-on";
    } else if (/factor/i.test(dataType)) {
      return "fas fa-factor";
    } else if (/character/i.test(dataType)) {
      return "fas fa-font";
    } else if (/Date/.test(dataType)) {
      return "far fa-calendar";
    }
    return "fas fa-question";
  }
  
  const pageTypeField = window.top.document.getElementsByName('page-type');
  let isDictionary = false;
  if (pageTypeField && pageTypeField[0] && pageTypeField[0].value === 'DICTIONARY') {
    isDictionary = true;
  }
  let pageNumber = pageIndex+1;
  let showOnlyRightDots = pageCount > 7 && pageNumber < 7;
  let showBothDots = pageCount > 7 && pageNumber > 4 && pageNumber <= pageCount - 2;
  let showOnlyLeftDots = pageCount > 7 && pageNumber > pageCount - 3 && pageNumber <= pageCount;
  let thirdButtonPageNumber = showBothDots ? pageNumber - 1 : (showOnlyLeftDots ? pageCount - 4 : 3);
  let thirdButtonGotoPage = showOnlyLeftDots||showBothDots ? pageIndex - 1: thirdButtonPageNumber - 1;
  let fourthButtonPageNumber = showBothDots ? pageNumber : (showOnlyLeftDots ? pageCount - 3 : 4);
  let fourthButtonGotoPage = fourthButtonPageNumber-1;
  let fifthButtonPageNumber = showBothDots ? pageNumber + 1 : (showOnlyLeftDots ? pageCount - 2 : 5);
  let fifthButtonGotoPage = 0; //showBothDots ? fifthButtonPageNumber : showOnlyLeftDots ?  : showOnlyRightDots ? 4 : pageNumber-1;
  if(showBothDots) {
    fifthButtonGotoPage = fifthButtonPageNumber - 1;
    if(pageNumber === 5 && fifthButtonPageNumber === 6) { // special case
      fifthButtonGotoPage = 5;
    }
  } else if (showOnlyLeftDots) {
    fifthButtonGotoPage = pageCount - 3;
  } else if(pageNumber > fifthButtonPageNumber){
    fifthButtonGotoPage = pageNumber;
  } else {
    fifthButtonGotoPage = 4;
  }
  
  /**
   * API to update iframe element height as well as wrapper div height on parent window. 
   * @param {Number} size
   */
  const updateParentIframeSize = size => {
    let height = 528 + (size - 10) * 33 + 20 /*for padding bottom*/;
    if (10 < rows.length && rows.length <= size) {
      height = 528 + (rows.length - 10) * 33 + 20 /*for padding bottom*/;
    }
    if(window.frameElement) {
      window.frameElement.style.height = height + "px";
    }
    let wrapper = window.top.document.querySelector('.data-pane-wrapper');
    if(wrapper) {
      wrapper.style.height = height + "px";
    }
  };
  
  /**
   * Number Formatter: Use d3 which is available on parent windows.
   */
  const formatter = window.top && window.top.d3 ? window.parent.top.d3.format(',') : function(text){return text};

  /**
   * pagination widget
   */
  let pagination = (
      <div className="pagination">
          <div className="rows-info">
            {pageSize > rows.length ? formatter(rows.length) : formatter(pageSize)} of <strong>{formatter(rows.length)}</strong> Rows 
          </div>
          <select
            value={pageSize}
            onChange={e => {
              updateParentIframeSize(e.target.value);
              setPageSize(Number(e.target.value))
            }}
          >
            {[20, 50, 100, 200].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize} Rows
              </option>
            ))}
          </select>

          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'Previous'}
          </button>{' '}
          <button onClick={() => gotoPage(0)}>
            {1 === pageNumber ? <span><strong>{1}</strong></span> : <span>1</span>}
          </button>
          {(showOnlyLeftDots || showBothDots) ? " ... " : <button className={ 2 > pageCount ? "hidden" : ""} onClick={() => gotoPage(pageIndex < 3 ? 1 : 0)}>
            {2 === pageNumber ? <span><strong>{2}</strong></span> : <span>2</span>}
          </button>}
          <button className={ 3 > pageCount ? "hidden" : ""} onClick={() => gotoPage(thirdButtonGotoPage)}>
            {thirdButtonPageNumber === pageNumber ? <span><strong>{thirdButtonPageNumber}</strong></span> : <span>{thirdButtonPageNumber}</span>}
          </button>
          <button className={ 4 > pageCount ? "hidden" : ""} onClick={() => gotoPage(fourthButtonGotoPage)}>
            {fourthButtonPageNumber === pageNumber ? <span><strong>{fourthButtonPageNumber}</strong></span> : <span>{fourthButtonPageNumber}</span>}
          </button>
          <button className={ 5 > pageCount ? "hidden" : ""} onClick={() => gotoPage(fifthButtonGotoPage)}>
            {fifthButtonPageNumber === pageNumber ? <span><strong>{fifthButtonPageNumber}</strong></span> : <span>{fifthButtonPageNumber}</span>}
          </button>
          { (showBothDots || showOnlyRightDots) ? " ... " :  <button className={ 6 > pageCount ? "hidden" : ""} onClick={() => gotoPage(pageCount-2)}>
            {pageCount - 1 === pageNumber ?  <span><strong>{pageCount-1}</strong></span> : <span>{pageCount-1}</span>}
          </button> }
          <button className={ 7 > pageCount ? "hidden" : ""} onClick={() => gotoPage(pageCount - 1)}>
            {pageCount === pageNumber ?  <span><strong>{pageCount}</strong></span> : <span>{pageCount}</span>}
          </button>
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {'Next'}
          </button>{' '}
        </div>)

  const hasNonAscii = (str) => {
    // ref: https://stackoverflow.com/questions/14313183/javascript-regex-how-do-i-check-if-the-string-is-ascii-only
    const ascii = /^[\x00-\x7F]*$/;
    if ( !ascii.test( str ) ) {
      return true;  // string has non-ascii characters
    }
    return false;
  }
  /**
   * API to render Cell content
   * @param {Object} cell - cell object
   * @param {Object} maxValues - hashtable of max values. Key is column name.
   * @param {Object} minValues - hashtable of min values. Key is column name.
   * @param {Object} summaryJSON - JSON object for summary view info.
   * @param {Number} rowIndex - index of the row.
   */
  const cellRenderer = (cell, maxValues, minValues, summaryJSON, rowIndex) => {
    if(cell.column.isId) { // for id cell, always show the sorted row number.
      return rowIndex + 1; // rowIndex starts with 0
    }
    const threshHold = hasNonAscii(cell.value) ? SHOW_TOOLTIP_NON_ASCII_THRESHOLD : SHOW_TOOLTIP_THRESHOLD;
    if(!cell.column.isId && ["character", "factor", "list"].indexOf(cell.column.dataType) > -1 && 
      cell.value !== null && cell.value !== undefined && (cell.value.startsWith && (cell.value.startsWith("http://")||cell.value.startsWith("https://")))) {
      if(cell.value.length > threshHold) {
        let style = {"maxWidth": "400px", "wordWrap":"break-word"};
        return (
          <Tooltip
            trigger={["hover"]}
            overlayClassName={'super-table'}
            placement="top"
            overlayStyle={style}
            overlay={<span>{cell.value}</span>}>
            <a href={cell.value} target={"_blank"}>{cell.value}</a>
          </Tooltip>
        );
      }
      return (<a href={cell.value} target={"_blank"}>{cell.value}</a>);
    } else if (cell.value === null) {
      return "<NA>";
    } else if (cell.column.dataType.indexOf('POSIX') > -1){ 
      // when the column name contains "." column.id is not equal to column name, in this case use column.Header
      let hist = summaryJSON && summaryJSON[3] ? (summaryJSON[3][cell.column.id] || summaryJSON[3][cell.column.Header]) : null;
      let tz = '';
      if (hist) {
        let tz = hist[5][0];
        // If the timezone string is the difference from GMT like "-10", "+4",
        // then add "GMT" at the beginning.
        if (/^[+-]/.test(tz)) {
          tz = "GMT"+tz;  
        }  
      }
      // parent window has moment so use it to format date.
      return window.parent.moment(cell.value).format("YYYY-MM-DD HH:mm:ss") + " " + (tz||'');
    } else {      
      if(cell.column.isSorted && ["numeric","integer"].includes(cell.column.dataType)) {
        let attrs = calculateBarAttributes(cell, maxValues, minValues);
        let style = {};
        style.width = attrs.width;
        if(attrs.left) {
          style.left = attrs.left;
        }
        return [<div className={"sorted-bar" + attrs.colorClass} style={style}></div>, <span className="sorted-value-span">{formatter(cell.value)}</span>];
      } else if (cell.value !== null && cell.value !== undefined && cell.value.length > threshHold) {
        const formattedValue = ["numeric","integer"].includes(cell.column.dataType) ? formatter(cell.value) : cell.value;
        const style = {"maxWidth": "400px", "wordWrap":"break-word"};
        return (
          <Tooltip
            trigger={["hover"]}
            overlayClassName={'super-table'}
            placement="top"
            overlayStyle={style}
            overlay={<span>{formattedValue}</span>}>
            <span>{formattedValue}</span>
          </Tooltip>
        );
      } else if (["numeric","integer"].includes(cell.column.dataType)){
        return formatter(cell.value);
      }
      return cell.render('Cell');
    }
  }
  
  /**
   * API to calculate attributes of the bar rendered inside numeric cell
   * @param {Object} cell - cell object from react-table
   * @param {Object} maxValues - hashtable of max values. Key is column name.
   * @param {Object} minValues - hashtable of min values. Key is column name.
   */
  const calculateBarAttributes = (cell, maxValues, minValues) => {
    let colKey = cell.column.index;
    let maxVal = maxValues[colKey];
    if(maxVal < 0) {
      maxVal = 0;
    }
    let minVal = Math.min(0, minValues[colKey]); //  include zero all the time because bar should start from 0.
    let scaleFunc = window.top.d3.scale.linear().domain([minVal, maxVal]).range([0,100]);
    let zeroPoint = scaleFunc(0);
    let dataPoint = scaleFunc(cell.value);
    let left = cell.value < 0 ? dataPoint+'%' : zeroPoint+'%';
    let width = Math.abs(zeroPoint-dataPoint)+'%';
    let colorClass = cell.value < 0 ? ' negative' : '';
    if(cell.value > 0) {
      // it has total 20px padding (padding-left 10px and padding-right 10px)
      // So discount the padding with width percentage and subtract it.
      let adjust = (20 * Math.abs(zeroPoint-dataPoint)) / 100 + "px";
      if(zeroPoint > 0) { // need to set left
        return {
          "colorClass": colorClass, 
          "width": "calc(" + width + " - " + adjust + ")",
          "left": "calc(" + left + ")"
        };
      } else { // no need to set left
        return {
          "colorClass": colorClass, 
          "width": "calc(" + width + " - " + adjust + ")",
        };        
      }
    } else {
      let rawWidth = Math.abs(zeroPoint-dataPoint);
      let rawLeft = dataPoint;
      let leftAdjust = (10 - (20 * rawLeft) / 100) + "px";
      let widthAdjust = (20 * rawWidth) / 100 + "px";
      return {
        "colorClass": colorClass, 
        "width":  "calc(" + width + " - " + widthAdjust + ")", 
        "left": "calc(" + left + " + " + leftAdjust +")"
      };
    }
  }
  
  /**
   * API to return HTML class name of the Column (td)
   * @param {Object} cell - cell object from react-table
   */
  const getColumnClass = cell => {
    if( ["numeric","integer"].indexOf(cell.column.dataType) > -1) {
      if(cell.value === null/*"NA"*/) {
        return "right is-na";
      } else if (cell.column.isSorted) {
        return "right sorted";
      }
      return "right";
    } else if (cell.column.dataType === "") {
      return "is-id";
    } else if(cell.value === null/*"<NA>"*/) {
      return "is-na";
    } else if (["character","factor"].indexOf(cell.column.dataType) > -1) {
      return "character";
    }
    return "";
  }
  
  /**
   * API to convert text to Title Case.
   *
   * @param   {string}  str  [str description]
   *
   * @return  {string}       [return description]
   */
  const toTitleCase = function(str) {
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  };
  
  /**
   * API to check if the first letter is Upper Case.
   *
   * @param   {string}  str  [str description]
   * @return  {boolean}       [return description]
   */
  const isFirstLetterUpperCase = function(str) {
    return str.charAt(0) === str.charAt(0).toUpperCase();
  };

  const getNormalizedColumnType = type => {
    if(type === "POSIXct,POSIXt") {
      return "POSIXct";
    }
    if (!isFirstLetterUpperCase(type)) {
      return toTitleCase(type);
    } else {
      return type;
    }
  }
  
  return (
  <div>
    {pagination}
    <div className="table-wrapper">
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>
                  <div {...column.getSortByToggleProps({"className":"column-name-wrapper"})}>
                  <Tooltip
                    overlayClassName={'super-table-column'}
                    trigger={["hover"]}
                    placement="top"
                    overlay={<span>{column.id}</span>}>
                    <div className={["numeric","integer"].indexOf(column.dataType) > -1 ? "column-name numeric" : "column-name"}>{
                       column.render('Header')
                    }
                      <span className={["numeric","integer"].indexOf(column.dataType) > -1  ? "column-sort numeric" : "column-sort"}>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? <i style={{"padding-left": "2px"}} className="fa fa-caret-down"></i>
                            : <i style={{"padding-left": "2px"}} className="fa fa-caret-up"></i>
                          : ''}
                      </span>
                    </div>
                  </Tooltip>
                  <div className={["numeric","integer"].indexOf(column.dataType) > -1  ? "column-type numeric" : "column-type"}>
                    <i className={column.dataType ? getDataTypeIcon(column.dataType): ""}/><span>{getNormalizedColumnType(column.dataType)}</span>
                  </div>  
                  </div>
                  <div className={(column.canFilter ? (["numeric","integer"].indexOf(column.dataType) > -1 ? "filter-container numeric" : "filter-container") : "filter-container empty") + (isDictionary ? " dictionary" : "")}>{column.canFilter ? column.render('Filter') : null}</div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {page.map(
            (row, i) =>
              prepareRow(row) || (
                <tr {...row.getRowProps()} onClick={(event) => {
                  if (!row.isSelected) {
                    row.isSelected = true;
                  } else {
                    row.isSelected = false;
                  } 
                  let target = event.target;
                  if (target) {
                    if (target.nodeName === "TD") {
                      target = target.parentElement;
                    }
                    if (!target.classList.contains('selected')) {
                      target.classList.add('selected');
                    } else {
                      target.classList.remove('selected');
                    }
                  }
                }}>
                  {row.cells.map(cell => {
                    return (
                      <td {...cell.getCellProps({className: getColumnClass(cell)})}>
                        {cellRenderer(cell, maxValues, minValues, summaryJSON, i)}
                      </td>
                    )
                  })}
                </tr>
              )
          )}
        </tbody>
      </table>
    </div>
  </div>)
}

class App extends Component {
  
  constructor(){
    super();
    this.state = {
      rows: [],
      columns: [],
      maxValues: {},
      minValues: {},
      summaryJSON: []
    };
    this.counter = 0;
  }
  
  isInColumnarFormat(data) {
    // check the given object is in array format or not.
    return Object.prototype.toString.call(data) !== '[object Array]';
  };

  initializeData(e){
    if(e && e.data === "refresh") {
      return this.fetchData();
    }
  }
  
  componentDidMount(){
    if (window.addEventListener) {
      // Make sure to bind "App instance" as "this" when we add the message event listener. 
      // Otherwise corresponding API call invoked from initializeData API fails 
      // because "this" points to window object (NOTE: window object does not have fetchData API) instead of App instance.
      // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/this
      // for details.
      window.addEventListener("message", this.initializeData.bind(this), false);
    }
    this.fetchData();
  };
  
  componentWillUnmount(){
    if (window.addEventListener) {
      window.removeEventListener("message",this.initializeData);
    }
  }
  
  componentDidUpdate(){
    // make sure to hide spin on parent window.
    let wrapper = window.top.document.querySelector('.super-table.loading');
    if(wrapper) {
      wrapper.style.display = 'none';
    }
  };

  /**
   * Wrapper API for fetching data from server side.
   */
  fetchData(){
    const self = this;
    // Check if the caller (datablog) side is ready for required json file. If it's not ready yet,
    // wait till it's becomes available.
    if(window.parent.exploratory && window.parent.exploratory.summary && window.parent.exploratory.summary._json) {
      self.counter = 0;
      // The caller (datablog) is ready so get sample data.
      if (this.isWebR()) {
        return this._fetchDataForWebR();
      }
      return this._fetchData();
    } else if (self.counter < 50) {
      self.counter++;
      // Wait 100 milliseconds and try until it reaches maximum retry (50). 
      setTimeout(() => {
        if (this.isWebR()) {
          return this._fetchDataForWebR();
        }
        return self.fetchData();
      },100);
    } else {
      // Parent is not ready so gave up for Rendering and clean counter.
      self.counter = 0;
      // if this is for public project, show table without summary json.
      if (window.parent.location.pathname.startsWith("/project/")) {
        if (this.isWebR()) {
          return this._fetchDataForWebR();
        }
        return this._fetchData();
      }  
      // make sure to hide spin on parent window.
      let wrapper = window.top.document.querySelector('.super-table.loading');
      if(wrapper) {
        wrapper.style.display = 'none';
      }
      let messageWrapper = window.top.document.querySelector('.super-table.not-found.hidden');
      if(messageWrapper) {
        messageWrapper.classList.remove('hidden');
      }
    }
  };

  isWebR() {
    if (window.parent.exploratory && window.parent.exploratory.ia && window.parent.exploratory.ia._webR) {
      return true;
    }
    return false;
  }

  _fetchDataForWebR() {
    let urlParams = new URLSearchParams(window.location.search);
    const itemDagId = urlParams.get("itemDagId");
    let _data = '';
    if (itemDagId && this.isWebR()) { // it means WebR case.
      let cols = [];
      let rows = [];
      let maxValues = {};
      let minValues = {};
      let summaryJSON = window.parent.exploratory && window.parent.exploratory.summary ? window.parent.exploratory.summary._json : {};
      let superTableData = window.parent.exploratory.ia.getSuperTableData(itemDagId);
      let data = superTableData && superTableData.data && !superTableData.data.rows && this.isInColumnarFormat(superTableData.data) ? superTableData.data : null;
      // Do nothing if it is not in a columnar style data. 
      if (data) {
        _data = data;
        cols = data.cols;
        rows = data.rows;
        let columnsHash = {};
          superTableData.columns.forEach(_column => {
            columnsHash[_column.name] = _column;
          })
        let _cols = Object.keys(_data);
        rows = [];
        let idx = 0;
        let row = null;
        // This guarantees that there's at least one column in the given data.
        if (_cols.length === 0) {
          return rows;
        }
        while(idx < _data[_cols[0]].length) {
          row = {};
          // We should follow column order on _metadata.columns
          superTableData.columns.forEach((colObj, index) => {
            const col = colObj.name;
            const colKey = index+1; // index starts from 1 (since 0 is for row index)
            const isNumeric = columnsHash[col] && (columnsHash[col].isNumeric || ["numeric", "integer"].indexOf(columnsHash[col].type) > -1);
            const value = _data[col][idx];
            if(isNumeric && value === "NA") {
              row[colKey] = null; 
            } else {
              row[colKey] = value;
              if(isNumeric && value !== null) {
                if(maxValues[colKey] === undefined || maxValues[colKey] < value) {
                  maxValues[colKey] = value;
                }
                if(minValues[colKey] === undefined || minValues[colKey] > value) {
                  minValues[colKey] = value;
                }
              }
            }
          });
          rows.push(row);
          idx++;
        }
        this.setState({rows:rows, columns:superTableData.columns, nrow: superTableData.nrow, maxValues: maxValues, minValues: minValues, summaryJSON: summaryJSON});
        return true;
      } else {
        cols = superTableData.cols;
        rows = data.rows;
        this.setState({rows:rows, columns:cols, nrow: rows.length, maxValues: maxValues, minValues: minValues, summaryJSON: summaryJSON});
        return true;
      }
    }
  };
  /**
   * React Common API
   * When the component is mounted call server REST API to get json file.
   */
  _fetchData(){
    let self = this;
    // windows.location.href looks like this: http://localhost:3000/data/vFs3kQh5Jm/123flight-lbM1OkR2vl?url=/sample_data.json&metadataUrl=/dataframe_metadata.json
    let parentURL = window.parent.location.pathname;
    let urlParams = new URLSearchParams(window.location.search);
    let sampleDataFileName = urlParams.get("url") || "/sample_data.json";
    let metadataFileName = urlParams.get("metadataUrl") || "/dataframe_metadata.json";
    let cacheBuster = Date.now();
    let url = parentURL + sampleDataFileName + "?cb=" + cacheBuster; 
    let metadataUrl = parentURL + metadataFileName + "?cb=" + cacheBuster;
    let summaryJSON = window.parent.exploratory && window.parent.exploratory.summary ? window.parent.exploratory.summary._json : {};
    let isNewDataStyle = false;
    let cols = [];
    let rows = [];
    let maxValues = {};
    let minValues = {};
    let _data = '';
    return fetch(url)
    .then(result => {
      return result.json();
    })
    .then(data => {
      // Do nothing if it is not in a columnar style data. 
      if (data && !data.rows && self.isInColumnarFormat(data)) {
        isNewDataStyle = true;
        _data = data;
        return fetch(metadataUrl);
      } else {
        cols = data.cols;
        rows = data.rows;
        self.setState({rows:rows, columns:cols, nrow: rows.length, maxValues: maxValues, minValues: minValues, summaryJSON: summaryJSON});
        return true;
      }
    })
    .then(columnsRes => {
      if(isNewDataStyle) {
        return columnsRes.json();
      }
      return true;
    })
    .then(function(_metadata){
      if(isNewDataStyle) {
        let columnsHash = {};
         _metadata.columns.forEach(_column => {
           columnsHash[_column.name] = _column;
         })
        let _cols = Object.keys(_data);
        rows = [];
        let idx = 0;
        let row = null;

        // This guarantees that there's at least one column in the given data.
        if (_cols.length === 0) {
          return rows;
        }

        while(idx < _data[_cols[0]].length) {
          row = {};
          // We should follow column order on _metadata.columns
          _metadata.columns.forEach((colObj, index) => {
            const col = colObj.name;
            const colKey = index+1; // index starts from 1 (since 0 is for row index)
            const isNumeric = columnsHash[col] && (columnsHash[col].isNumeric || ["numeric", "integer"].indexOf(columnsHash[col].type) > -1);
            if(isNumeric && _data[col][idx] === "NA") {
              row[colKey] = null; 
            } else {
              row[colKey] = _data[col][idx];
              if(isNumeric && _data[col][idx] !== null) {
                if(maxValues[colKey] === undefined || maxValues[colKey] < _data[col][idx]) {
                  maxValues[colKey] = _data[col][idx];
                }
                if(minValues[colKey] === undefined || minValues[colKey] > _data[col][idx]) {
                  minValues[colKey] = _data[col][idx];
                }
              }
            }
          });
          rows.push(row);
          idx++;
        }
        self.setState({rows:rows, columns:_metadata.columns, nrow: _metadata.nrow, maxValues: maxValues, minValues: minValues, summaryJSON: summaryJSON});
      }
      return true;
    })
    .catch(err => {
      console.error(err);
    });
  }

  isDictionary() {
    const pageTypeField = window.top.document.getElementsByName('page-type');
    let isDictionary = false;
    if (pageTypeField && pageTypeField[0] && pageTypeField[0].value === 'DICTIONARY') {
      isDictionary = true;
    }
    return isDictionary;
  }
  
  render() {
    let data = this.state.rows.map( (row, index) =>{
      return {"__super_table_row_id__": index+1, ...row};
    });
    let self = this;
    if(this.state.search) {
        data = data.filter(row => {
          return Object.values(row).some(column => {
            if(column === null || column === undefined || column === "") {
              return false;
            }
            let _col = column;
            if(Array.isArray(column)) { // if it's an array (like a list column) make it as an string.
              _col = column.join(" ");
            }
            return _col.includes ? _col.toLowerCase().indexOf(this.state.search) > -1 : _col.toString().indexOf(this.state.search) > -1;
          });
        });
    }
    let columns =  this.state.columns.map((column, index) => {
      // To work around the issue that data is not shown when accessor is based on column name and the column name contains special characters, use index for accessor.
      let _col = {
        Header: column.name, 
        accessor: (value) => {return value[index+1]},// index starts from 1 (since 0 is for row index)
        dataType: column.type,
        sortType: column.isNumeric || ["numeric","integer"].indexOf(column.type) > -1 ? "basic" : "alphanumeric",
        filter: 'text'
      };
      return _col;
    });
    columns.unshift({
      Header: "", 
      accessor: "__super_table_row_id__",
      isId: true,
      dataType: "",
      disableFilters: true
    })
    
    let defaultSorted = this.state.columns.map(column => {
      return {id: column.name,desc: false};
    });

    if(data.length >= 0 && columns.length > 1) {
      return (
        <Styles>
          <div>
            <span className="fal fa-search"></span>
            <DebounceInput 
              className={"global-search " + (this.isDictionary() ? " dictionary" : "")} 
              type="text" 
              placeholder="Type to search" 
              debounceTimeout={200}
              minLength={2}
              onChange={e => {self.setState({"search":String(e.target.value).toLowerCase()})}}/>
          </div>
          <Table columns={columns} 
                 data={data}
                 defaultSorted={defaultSorted}
                 nrow={this.state.nrow}
                 maxValues={this.state.maxValues}
                 minValues={this.state.minValues}
                 summaryJSON={this.state.summaryJSON}/>
        </Styles>
      ); 
    } else {
      return <div></div>
    }
  }
}

export default App
